import { Component, ErrorHandler, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { interval } from 'rxjs/observable/interval';
import { Subscription } from 'rxjs/Subscription';
import { ChangeDetectorRef } from '@angular/core';
import { WindowRef } from '../../shared/windowRef.service';

declare var $: any; // Declare jQuery globally
@Component({
  selector: 'app-registration-new',
  templateUrl: './registration-new.component.html',
  styleUrls: ['./registration-new.component.css'],
  providers: [WindowRef]
})
export class RegistrationNewComponent {
  @ViewChild('registerForm') registerForm: NgForm;
  //export class RegistrationNewComponent implements OnInit {

  //OnInit
  //AfterViewInit 
  // @ViewChild('registerForm') registerForm: NgForm;
  v: any = {};
  Confirm_Password: string;
  Districts: any;
  data: any;
  Categories: any;
  fileToUpload: File = null;

  formInvalid: boolean;
  numericpattern = "^[0-9]*$";
  Password: string = '';
  showPassword: boolean = false;
  showPassword1: boolean = false;
  Reservations: any;
  maxDate: any = new Date();
  EmplAge: any;
  applicantAge: number;
   selectedIDProof: string = '';
idProofNo: string = '';

idProofPattern: string = '';
maxLength: number = 0;
minLength: number = 0;
placeholder: string = 'Enter ID Proof Number';
  username: string = 'BIHAREDISTRICT-housingboard';
  password: string = 'Bshb@202411';
  senderid: string = 'BRGOVT';
  mobileNo: any;
  message: string = 'TheOTPforverificationisBiharStateHousingBoard';
   //secureKey: string = '21b208aa-bb42-4c19-8d93-b8571a7d40d6';
  secureKey: string = '71af7035-7391-4f59-b251-63e25907bd1e';
  templateid: string = '1307165356165028460';
  value: any;
  PhoneNumber: any;
  showResendButton: boolean = false;
  minutes: number = 2;
  seconds: number = 0;
  timerSubscription: Subscription;
  timerExpired: boolean = false;
  Banks: any;
  Branches: any = {};
  AppRefNo: any;
  Message: any;
  otpExpired: boolean;
  APP_PA_Age: number;
  hide: boolean = false;
  pay_data: any;
  pay_formData: any;
  pay_district_name: any;
  transactionId: string = '';
  paymentStatus: string = '';
  Online_Payment_Date: any;
  hasClickedPay = false;
  formSaved: boolean = false;
  MessageV: any;
  isVoterIdValid: boolean = false;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler, private datePipe: DatePipe,winRef: WindowRef) {

  }

  ngOnInit() {
   
     console.log("📢 ngOnInit in LoginComponent");
    window.addEventListener("message", this.receivePaymentMessage.bind(this), false);
    console.log("✅ Message listener added.");
    this.GetAllDistrict();
    this.getReservationsforregister();

    this.GetAllBanksforregistration();
      const urlParams = new URLSearchParams(window.location.search);
      this.transactionId = urlParams.get('txnid') || '';
      this.paymentStatus = urlParams.get('status') || '';
      this.Online_Payment_Date = urlParams.get('addedon') || '';





  // ngOnInit() {

  // this.GetAllDistrict();
  // this.getReservationsforregister();
  // this.GetAllBanksforregistration();

  // // Read Easebuzz return parameters
  // const params = new URLSearchParams(window.location.search);

  // this.transactionId = params.get('txnid') || '';
  // this.paymentStatus = params.get('status') || '';
  // this.Online_Payment_Date = params.get('addedon') || '';









    //    if (localStorage.getItem('paymentDone') === 'true') {
    //     this.addBeforeUnloadProtection();
    // }

    // const savedForm = localStorage.getItem('savedRegistrationForm');
    // if (savedForm) {
    //     this.registerForm.setValue(JSON.parse(savedForm));
    // }

    // this.registerForm.valueChanges.subscribe(() => {
    //     this.saveFormDataToLocal();
    // });





  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  togglePasswordVisibility1(): void {
    this.showPassword1 = !this.showPassword1;
  }
 
 saveFormDataToLocal() {
    localStorage.setItem('savedRegistrationForm', JSON.stringify(this.registerForm.value));
}



  Timer() {
    //debugger;
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    //this.timerSubscription.unsubscribe();
    this.minutes = 2;
    this.seconds = 0;
    this.otpExpired = false;
    // this.cdr.detectChanges();

    this.timerSubscription = interval(1000).subscribe(() => {
      if (this.seconds === 0) {
        if (this.minutes === 0) {
          //this.showResendButton = true;
          this.otpExpired = true;
          this.timerSubscription.unsubscribe();
        } else {
          this.minutes--;
          this.seconds = 59;
        }
      } else {
        this.seconds--;
      }
    });
  }
  SaveRegiter(registerForm: NgForm) {
    // alert(JSON.stringify(registerForm.value));
    //debugger;

    console.log("saheb final data send :" + JSON.stringify(registerForm.value));
    

    registerForm.value.ID_ProofFile_Doc = this.getApplicantIdFileInput();
    registerForm.value.Signature_File_Doc = this.getSignatureFileInput();
    //registerForm.value.IDProof_Name = "Cast Certificate";
    if (registerForm.invalid) {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }

    const datePipe = new DatePipe('en-US');

    // Transform dates with time
    registerForm.value.Submitted_Date = datePipe.transform(registerForm.value.Submitted_Date, 'MM/dd/yyyy hh:mm:ss a');
    registerForm.value.Online_Payment_Date = datePipe.transform(this.Online_Payment_Date, 'MM/dd/yyyy hh:mm:ss a');
    registerForm.value.Date_Of_Birth = datePipe.transform(registerForm.value.Date_Of_Birth, 'MM/dd/yyyy hh:mm:ss a');
    registerForm.value.Challan_Payment_Date = datePipe.transform(registerForm.value.Challan_Payment_Date, 'MM/dd/yyyy hh:mm:ss a');
    registerForm.value.Payment_Method = this.v.Payment_Method
    registerForm.value.Submitted_Date = new Date().toLocaleString();


    // registerForm.value.Payment_Method = this.v.Payment_Method;
registerForm.value.Payment_Status = this.paymentStatus;
registerForm.value.Transaction_Id = this.transactionId;
registerForm.value.Online_Payment_Date = (this.paymentStatus === 'success')
  ? datePipe.transform(this.Online_Payment_Date, 'MM/dd/yyyy hh:mm:ss a')
  : null;
registerForm.value.Paid_Amount =  (this.paymentStatus === 'success') ? 200 : 0;
  registerForm.value.Payment_Method  =  'Online';


console.log("Payment details being saved:", {
  status: registerForm.value.Payment_Status,
  transactionId: registerForm.value.Transaction_Id,
  date: registerForm.value.Online_Payment_Date,
  method: registerForm.value.Payment_Method
});

    if (registerForm.value.ID_ProofFile_Doc == null) {
      this.formInvalid = true;
      swal('Warning!', 'Please upload file.', 'warning');
      return;
    } else {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.PostRegiter(registerForm.value);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";

          if (response.App_No === "Applicant already registered") {
            swal('Error!', 'Applicant is already registered.', 'error');
            return;
          }else if (response.App_No === "Invaid Transaction Id") {
            swal('Error!', 'Invaid Transaction Id.', 'error');
            return;
          }

              this.formSaved = true;
              // localStorage.removeItem('paymentDone');
              // localStorage.removeItem('savedRegistrationForm');
              this.removeBeforeUnloadProtection();

          // registerForm.reset();
          // registerForm.resetForm();
          // registerForm.form.markAsPristine();
          // registerForm.form.markAsUntouched();
          swal('Success!', 'Thank You, Your Registration Number is delivered to your Registered Mobile number. (धन्यवाद, आपका पंजीकरण नंबर आपके पंजीकृत मोबाइल नंबर पर भेज दिया गया है।)', 'success');
          console.log("Register:", registerForm.value);
           console.log("Mobile:", registerForm.value.Mobile_No);
          this.router.navigate(
  ['/payment-summary'],
  { queryParams: { appNo: response.App_No} }
);
  registerForm.reset();
          registerForm.resetForm();
          registerForm.form.markAsPristine();
          registerForm.form.markAsUntouched();
          // this.router.navigate(['/payment-summary']);
        },
        (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401) {
            this.errorHandler.handleError(error);
          } else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }
      );
    }

    if (this.Password === this.Confirm_Password) {
      console.log('Form Submitted');
    } else {
      console.error('Passwords do not match');
    }
  }


  getReservationsforregister() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getReservationsforregister();
    this.data.subscribe(
      (response: any) => {
        this.Reservations = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllDistrict() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistrictNameforregister();
    this.data.subscribe(
      (response: any) => {
        this.Districts = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  ApplicantId(file: FileList) {
 
    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(\.jpeg|\.jpg|\.png)$/i;
    // let regex = /^([a-zA-Z0-9\s_\.\-\:\(\)\\])+(\.jpeg|\.jpg|\.png|\.pdf)$/i;
    // let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
 let regex = /^[^\\/]+\.pdf$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);  
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          this.v.ApplicantId_CertificateErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('ID_ProofFile_Doc');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('ID_ProofFile_Doc');
      i.value = "";
      if (!uploadedFilename.match(regex))
       swal('Warning!', "Please upload file with extension  PDF", 'warning');

      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getApplicantIdFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('ID_ProofFile_Doc');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


  SignatureFileInput(file: FileList) {


    // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(\.jpeg|\.jpg)$/i;
    // let regex = /^([a-zA-Z0-9\s_\.\-\:\(\)\\])+(\.jpeg|\.jpg|\.png|\.pdf)$/i;

// let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
let regex = /^[^\\/]+\.pdf$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.UO_UploadimageUrl1 = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          console.log(response);
          
          this.v.Signature_CertificateErrorMessage = "";
        }, (error) => {
          let i: any = document.getElementById('Signature_File_Doc');
          i.value = "";
          if (error.status == 400) {
            // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Signature_File_Doc');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload file with extension  PDF ", 'warning');

      else if (size > 2048)
        swal('Warning!', "Please upload file less than 2mb", 'warning');
    }
  }

  getSignatureFileInput() {
    let imagename = null;
    try {
      imagename = document.getElementById('Signature_File_Doc');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  dateChange(Date) {
    this.data = this.userService.calculateAgeforregister(Date);
    this.data.subscribe(
      (response: any) => {
        response;
        this.APP_PA_Age = response;
        if (this.APP_PA_Age > 18) {
        }
        else {
          this.v.Date_Of_Birth = null;
          document.getElementById('loader-spinner').style.display = "none";
          swal('Warning!', "Age cannot be less than 18 years", 'warning');
        }
      })

  }



onIDProofChange() {

  this.v.Aadhar_No = '';

  switch (this.selectedIDProof) {

    case 'Aadhaar':
      this.idProofPattern = '^[0-9]{12}$';
      this.minLength = 12;
      this.maxLength = 12;
      this.placeholder = 'Ex: 123456789012';
      break;

    case 'DrivingLicense':
    //   this.idProofPattern = '^[A-Z0-9]{10,20}$';
    //   this.minLength = 10;
    //   this.maxLength = 20;
    //   this.placeholder = 'Ex: BH0120201234567';
    //   break;
     //this.idProofPattern = '^[A-Z]{2}-?[0-9]{10,15}$';
    this.idProofPattern = null;;
    this.minLength = 12;
    this.maxLength = 18;
    this.placeholder = 'Ex: BR0160104098633 ';
break;
      
    case 'Passport':
      this.idProofPattern = '^[A-Z][A-Z0-9][0-9]{6}$';
      this.minLength = 8;
      this.maxLength = 8;
      this.placeholder = 'Ex: A1234567 , AG2772272';
   break;

    case 'RationCard':
      this.idProofPattern = '^[A-Z0-9]{10,20}$';
      this.minLength = 10;
      this.maxLength = 20;
      this.placeholder = 'Ex: RATION12345';
      break;

    case 'VoterID':
      this.idProofPattern = '^[A-Z]{3}[0-9]{7}$';
      this.minLength = 10;
      this.maxLength = 10;
      this.placeholder = 'Ex: ABC1234567';
      break;

    // case 'BankPassbook':
    //   this.idProofPattern = '^[0-9]{9,18}$';
    //   this.minLength = 9;
    //   this.maxLength = 18;
    //   this.placeholder = 'Ex: 123456789012';
    //   break;

    default:
      this.idProofPattern = '';
      this.minLength = 0;
      this.maxLength = 0;
      this.placeholder = 'Enter ID Proof Number';
  }
}

  // onIDProofChange() {
  //   if (this.selectedIDProof === 'Pan Card') {
  //     this.idProofPattern = '^[A-Z]{5}[0-9]{4}[A-Z]$'; // Pattern for PAN Card
  //     this.maxLength = 10;
  //     this.minLength = 10;
  //     this.placeholder = 'Ex:AAAAA0000A';
  //   } else if (this.selectedIDProof === 'Aadhar Card') {
  //     this.idProofPattern = '^[0-9]{12}$'; // Pattern for Aadhar Card
  //     this.maxLength = 12;
  //     this.minLength = 12;
  //     this.placeholder = 'Ex:123456789123';
  //   } else if (this.selectedIDProof === 'Driving License') {
  //     this.idProofPattern = '^[A-Z0-9]{10,15}$'; // Pattern for Driving License
  //     this.maxLength = 15;
  //     this.minLength = 10;
  //     this.placeholder = 'Ex: 123456789123';
  //   } else if (this.selectedIDProof === 'Ration Card') {
  //     this.idProofPattern = '^[A-Z0-9]{10,20}$'; // Pattern for Ration Card
  //     this.maxLength = 20;
  //     this.minLength = 10;
  //     this.placeholder = 'Ex: 1234567891';
  //   } else {
  //     this.idProofPattern = '';
  //     this.maxLength = 0;
  //     this.minLength = 0;
  //     this.placeholder = 'Enter ID Proof Number';
  //   }
  //   this.idProofNo = '';
  // }


  // SaveMobileOTP(mobileNo: any) {
  //   //debugger

  //   var digits = '0123456789';
  //   let OTP = '';
  //   for (let i = 0; i < 4; i++) {
  //     OTP += digits[Math.floor(Math.random() * 10)];
  //   }

  //     this.message = 'The OTP for verification is' + " " + OTP + " " +'Bihar State Housing Board'

  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.PostMoileOTP(this.username, this.password, this.senderid, mobileNo, this.message, this.secureKey, this.templateid);
  //   this.data.subscribe(
  //     (response) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //       if(response == 'Applicant already registered')
  //       {
  //         $('#myModal').modal('hide');
  //          swal('Warning!',response, 'warning');
  //         //  this.hide = true;

  //       }
  //       // if (this.timerExpired && this.timerSubscription) {
  //       //   this.timerSubscription.unsubscribe(); // Unsubscribe only if expired
  //       // }
  //       this.Timer();
  //     },
  //     (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //       if (error.status == 401) {
  //         this.errorHandler.handleError(error);
  //       }
  //       else if (error.status == 400) {
  //         swal('Warning!', error.error.Message, 'warning');
  //       }
  //     }
  //   );
  // }

  SaveMobileOTP(mobileNo: any) {
    // debugger;
    

    var digits = '0123456789';
    let OTP = '';
    for (let i = 0; i < 4; i++) {
      OTP += digits[Math.floor(Math.random() * 10)];
    }

    this.message = 'The OTP for verification is ' + OTP + ' Bihar State Housing Board';

    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.PostMoileOTP(this.username, this.password, this.senderid, mobileNo, this.message, this.secureKey, this.templateid);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (response == 'Applicant already registered') {
          swal('Warning!', response, 'warning'); // Show SweetAlert warning
        } else {
          $('#myModal').modal('show'); // Show the modal if applicant is not registered
          this.Timer(); // Start the OTP timer
        }
      },
      (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        } else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }
    );
  }



  GetAllBanksforregistration() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllBanksforregistration();
    this.data.subscribe(
      (response: any) => {
        this.Banks = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  GetAllBranchforregistration(Bank_Name) {
    //debugger
    //this.v.Bank_Name = ba_id_fk;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getbranchfrombankforregistration(Bank_Name);
    this.data.subscribe(
      (response: any) => {
        this.Branches = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  VerifyMobileOTP(mobileNo: any, OTP: any) {
    //debugger
    this.PhoneNumber = mobileNo;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.PostVerifyMoileOTP(this.PhoneNumber, OTP);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        // registerForm.reset();
        swal('Success!', 'OTP verified successfully', 'success');
        this.v.otp = '';  // Reset OTP field to empty

        $('#myModal').modal('hide');
        this.v.isMobileVerified = true;
      },
      (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }
    );

  }

  Verifycast(IDProof_No: any,) {
    //debugger
    this.AppRefNo = this.v.IDProof_No;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.PostCast(this.AppRefNo);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        // registerForm.reset();
        this.data = response;
        this.Message = this.data.Message
        if (this.Message == 'Applicant with this caste certificate number is already registered') {
          swal('Warning!', this.Message, 'warning');
          // this.v.isCasteVerified = false;
        }
        else {
          swal('Success!', 'Caste Cerificate verified successfully', 'success');
          // this.v.isCasteVerified = true;
        }
        // this.v.isCasteVerified = true;
        // this.data = response;  
        // this.Message = this.data.Message

      },
      (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }
    );
  }
  
  //26/12/2025 working payment
  payment() {
    debugger


    
 if (this.hasClickedPay) return;

  this.hasClickedPay = true; // Disable button on first click
     if (!this.isFormValidWithoutTransactionId()) {
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }
    //saheb

    /*
    if (!this.registerForm || !this.registerForm.form) {
      alert("Form not initialized.");
      return;
    }

    if (!this.registerForm.valid) {
      console.warn("Form is invalid.");
      return;
    }
    */

    //console.log('registerForm object:', this.registerForm);
    //console.log('registerForm.value:', this.registerForm.value);

    // Find the district object by ID
    const selectedDistrict = this.Districts.find(
      d => Number(d.DI_Id) === Number(this.registerForm.value.District_Id_Fk)
    );

    console.log('selected dirst name :', selectedDistrict.DI_District);
    let fullDistrictName = selectedDistrict.DI_District;  // "Bhagalpur(भागलपुर)"
    let englishDistrictName = fullDistrictName.split('(')[0].trim();
    console.log('english dirst name :', englishDistrictName);

    this.pay_formData = this.registerForm.value;
    

  //  let firstname1= this.registerForm.value.Applicant_Name;
  //  let email1= this.registerForm.value.Email;
  // let  phoneno1= this.registerForm.value.Mobile_No;
  // let  amount1="100.00";
  // let  productinfo1= "Customer Registration Fee";
  // let  address1=this.registerForm.value.Village_Mohalla;
  //  let address2= this.registerForm.value.Post_Office;
  //  let city1=englishDistrictName;
  // let  zipcode1= this.registerForm.value.Pincode;

    console.log("Form data inside payment():", JSON.stringify(this.pay_formData));
        const paydata = {
    firstname: this.registerForm.value.Applicant_Name,
    email: this.registerForm.value.Email,
    phoneno: this.registerForm.value.Mobile_No,
    amount: "200.00",
    productinfo: "Customer Registration Fee",
    address1: this.registerForm.value.Village_Mohalla,
    address2: this.registerForm.value.Post_Office,
    city: englishDistrictName,
    zipcode: this.registerForm.value.Pincode
};
    console.log("requist  payment():", JSON.stringify(paydata));
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.Postpayment(paydata);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        // registerForm.reset();
         console.log('selected Response :', response);
        this.data = response;
        this.pay_data = this.data.data;
        console.log('pay data :' + this.pay_data);
        // Construct Easebuzz URL
        // for staging
        const easebuzzUrl = `https://testpay.easebuzz.in/pay/${this.pay_data}`;
        //for prod
          // const easebuzzUrl = `https://pay.easebuzz.in/pay/${this.pay_data}`;
        // Open the payment window (can be in a new tab or same tab)
        // window.open(easebuzzUrl, "_blank");  
        // OR use "_self" to open in the same tab
        // window.open(easebuzzUrl, "_self");
        // this.router.navigate(['/payment-success']);
              // Open the payment window in a new tab
      const paymentWindow = window.open(easebuzzUrl, "_blank");
            if (!paymentWindow) {
        swal('Warning!', 'Popup blocked. Please allow popups and try again.', 'warning');
        this.hasClickedPay = false;
        return;
      }

      // Poll every 500ms to check if the payment window is closed
      const checkClosed = setInterval(() => {
        if (paymentWindow && paymentWindow.closed) {
          clearInterval(checkClosed);
          this.hasClickedPay = false; // re-enable the button
          console.log("Payment window closed, button re-enabled");
        }
      }, 500);



      },
      (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.hasClickedPay = false;
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }
    );
  }








// payment() {

//   if (this.hasClickedPay) return;
//   this.hasClickedPay = true;

//   if (!this.isFormValidWithoutTransactionId()) {
//     swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
//     this.hasClickedPay = false;
//     return;
//   }

//   const selectedDistrict = this.Districts.find(
//     d => Number(d.DI_Id) === Number(this.registerForm.value.District_Id_Fk)
//   );

//   let city = '';
//   if (selectedDistrict && selectedDistrict.DI_District) {
//     city = selectedDistrict.DI_District.split('(')[0].trim();
//   }

//   const paydata = {
//     firstname: this.registerForm.value.Applicant_Name,
//     email: this.registerForm.value.Email,
//     phoneno: this.registerForm.value.Mobile_No,
//     amount: "200.00",
//     productinfo: "Customer Registration Fee",
//     address1: this.registerForm.value.Village_Mohalla,
//     address2: this.registerForm.value.Post_Office,
//     city: city,
//     zipcode: this.registerForm.value.Pincode
//   };

//   document.getElementById('loader-spinner').style.display = "block";

//   this.userService.Postpayment(paydata).subscribe(
//     (response: any) => {
//       document.getElementById('loader-spinner').style.display = "none";

//       const payKey = response && response.data ? response.data : null;
//       if (!payKey) {
//         swal('Error!', 'Payment initialization failed.', 'error');
//         this.hasClickedPay = false;
//         return;
//       }

//       // ✅ Mobile-safe redirect
//       window.location.href = 'https://pay.easebuzz.in/pay/' + payKey;
//     },
//     (error) => {
//       document.getElementById('loader-spinner').style.display = "none";
//       this.hasClickedPay = false;

//       const errMsg = error && error.error && error.error.Message
//         ? error.error.Message
//         : 'Something went wrong';

//       if (error.status === 400) {
//         swal('Warning!', errMsg, 'warning');
//       } else {
//         this.errorHandler.handleError(error);
//       }
//     }
//   );
// }







  isFormValidWithoutTransactionId(): boolean {
 if (!this.registerForm || !this.registerForm.controls) return false;
 
 // Loop through all controls
 for (const key in this.registerForm.controls) {
 if (key === 'Transaction_Id') continue; // Skip this field
 
 const control = this.registerForm.controls[key];
 
 // Check if control is invalid or empty
 if (!control || control.invalid || control.value === '' || control.value === null) {
 return false;
 }
 }
 
 return true; // All required fields (except Transaction_Id) are valid
 }


onTransactionIdChange(value: string): void {
  if (this.paymentStatus !== 'failure') {
    this.transactionId = value;
  }
}

   
    onPaymentModeChangeregfee(mode: string): void {
  
  if (mode === 'Online') {
    this.v.Bank_Name = null;
    this.v.Branch = null;
    this.v.Transaction_Id= null; // Clear Bank Challan Number
    this.v.Challan_Payment_Date = null;
    // this.paidAmount = this.paidAmount
    // this.PCA_InstallmemntNo = this.PCA_InstallmemntNo
  }
}




 trustedOrigins = [
    //'http://localhost:4200',        // your Angular app origin
     'https://portalbshb.esdinfra.com',

     //'http://localhost:14080',     // your payment API origin
    'https://BSHBAPI.esdinfra.com',

    'https://testpay.easebuzz.in'   // Payment provider domain
  ];

receivePaymentMessage(event: MessageEvent) {
  

    console.log("📬 Received message:", event);


    // if (!this.trustedOrigins.includes(event.origin)) {
    //   console.warn("Blocked origin:", event.origin);
    //   return;
    // }


    const data = event.data;
    if (data && data.txnid && data.status) {
      this.transactionId = data.txnid;
      this.paymentStatus = data.status;
      this.Online_Payment_Date = data.addedon;
      // Show alert or update UI
      //alert(`Payment Success!\nTransaction ID: ${this.transactionId}\nStatus: ${this.paymentStatus}`);
      console.log("saheb transaction Id :", this.transactionId);
      console.log("saheb payment Status :", this.paymentStatus);
       console.log("saheb Online Payment Date :", this.Online_Payment_Date);
         if (this.paymentStatus === 'success') {
          // localStorage.setItem('paymentDone', 'true');
      this.addBeforeUnloadProtection();
    }
    else if (this.paymentStatus != 'success') {
      this.hasClickedPay = false;
    }  // Optionally: enable Save button or auto-submit
    }
    else {
      console.warn("⚠️ Received message does not contain expected fields:", data);
      this.hasClickedPay = false;
    }
  }

  // VerifyVoterId(Aadhar_No: any,) {
  //   //debugger
  //   //this.AppRefNo = this.v.IDProof_No;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.VerifyVoterId(Aadhar_No);
  //   this.data.subscribe(
  //     (response) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //       // registerForm.reset();
  //       this.data = response;
  //       this.Message = this.data.Message
  //       if (this.Message == 'Applicant with this caste certificate number is already registered') {
  //         swal('Warning!', this.Message, 'warning');
  //         // this.v.isCasteVerified = false;
  //       }
  //       else {
  //         swal('Success!', 'Caste Cerificate verified successfully', 'success');
  //         // this.v.isCasteVerified = true;
  //       }
  //       // this.v.isCasteVerified = true;
  //       // this.data = response;  
  //       // this.Message = this.data.Message

  //     },
  //     (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //       if (error.status == 401) {
  //         this.errorHandler.handleError(error);
  //       }
  //       else if (error.status == 400) {
  //         swal('Warning!', error.error.Message, 'warning');
  //       }
  //     }
  //   );
  // }


     VerifyVoterId(Aadhar_No: any) {
      
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.userService.VerifyVoterId(Aadhar_No);
  this.data.subscribe(
    (response) => {
      document.getElementById('loader-spinner').style.display = "none";
      this.data = response;
      this.MessageV = this.data.Message;

      if (this.MessageV === 'Continue') {
        swal('Success!', 'Applicant with this ID Proof number not registered with BSHB. Please proceed.', 'success');
        this.isVoterIdValid = true;
      }
      else {
        swal('Info!', this.MessageV, 'info'); 
        this.isVoterIdValid = false;
      }
    },
    (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      if (error.status == 401) {
        this.errorHandler.handleError(error);
        this.isVoterIdValid = false;
      }
      else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');
        this.isVoterIdValid = false;
        
      }
      else {
        swal('Error!', 'Something went wrong. Please try again.', 'error');
        this.isVoterIdValid = false;
      }
    }
  );
}







// onVoterIdChange(Aadhar_No: any) {
//   debugger;
//   // Check if input is valid before calling API
//   if (Aadhar_No.valid && this.v.Aadhar_No.length === 10) {
//     this.VerifyVoterId(this.v.Aadhar_No);
//   }
// }




private idProofTimeout: any;              // debounce timer
private lastVerifiedIdProof: string = ''; // last verified value
//old
onIdProofValueChange(value: string) {

  if (!value || !this.selectedIDProof) {
    this.lastVerifiedIdProof = '';
    return;
  }

  clearTimeout(this.idProofTimeout);

  this.idProofTimeout = setTimeout(() => {

    const config = this.getIdProofConfig(this.selectedIDProof);

    if (!config) return;

    // length check
    if (value.length === config.length) {

      // pattern check
      if (config.pattern.test(value)) {

        // avoid duplicate API calls
        if (value !== this.lastVerifiedIdProof) {
          this.lastVerifiedIdProof = value;
          config.verifyFn(value);
        }

      } else {
        swal('Warning!', config.errorMsg, 'warning');
      }
    }

  }, 500); // debounce delay
}









getIdProofConfig(type: string) {

  switch (type) {

    case 'Aadhaar':
      return {
        length: 12,
        pattern: /^[0-9]{12}$/,
        errorMsg: 'Invalid Aadhaar number. Expected: 12 digits',
        verifyFn: (val: string) => this.VerifyVoterId(val)
      };

    case 'DrivingLicense':
      return {
        length: 15, // max length
        pattern: /^[A-Z0-9]{10,15}$/,
        //pattern: null,
        errorMsg: 'Invalid Driving License format',
        verifyFn: (val: string) => this.VerifyVoterId(val)
      };

    case 'Passport':
      return {
        length: 8,
        //pattern: /^[A-Z][0-9]{7}$/,
        pattern: /^[A-Z][A-Z0-9][0-9]{6}$/,
        errorMsg: 'Invalid Passport format. Expected: A1234567',
        verifyFn: (val: string) => this.VerifyVoterId(val)
      };

    case 'RationCard':
      return {
        length: 10, // minimum check
        pattern: /^[A-Z0-9]{10,20}$/,
        errorMsg: 'Invalid Ration Card number',
        verifyFn: (val: string) => this.VerifyVoterId(val)
      };

    case 'VoterID':
      return {
        length: 10,
        pattern: /^[A-Z]{3}[0-9]{7}$/,
        errorMsg: 'Invalid Voter ID. Expected: AAA0000000',
        verifyFn: (val: string) => this.VerifyVoterId(val)
      };

    // case 'BankPassbook':
    //   return {
    //     length: 9, // minimum length
    //     pattern: /^[0-9]{9,18}$/,
    //     errorMsg: 'Invalid Bank Account Number',
    //     verifyFn: (val: string) => this.VerifyVoterId(val)
    //   };

    default:
      return null;
  }
}


//   private voterIdTimeout: any;   
//   private lastVerifiedVoterId: string = '';  



// onVoterIdChange(value: string) {
  
//   const voterIdPattern = /^[A-Z]{3}[0-9]{7}$/;
//   if (!value) {
//     this.lastVerifiedVoterId = '';
//     return;
//   }

//   clearTimeout(this.voterIdTimeout);

//   this.voterIdTimeout = setTimeout(() => {
//     if (value.length === 10) {
//       if (voterIdPattern.test(value)) {
      
//         if (value !== this.lastVerifiedVoterId) {
//           this.lastVerifiedVoterId = value; 
//           this.VerifyVoterId(value);
//         }
//       } else {
//         swal('Warning!', 'Invalid Voter ID format. Expected: AAA0000000', 'warning');
//       }
//     }
//   }, 500); 
// }

  
beforeUnloadHandler = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = ''; // Standard way to show browser alert on close.
};

addBeforeUnloadProtection() {
  window.addEventListener('beforeunload', this.beforeUnloadHandler);.03

}

removeBeforeUnloadProtection() {
  window.removeEventListener('beforeunload', this.beforeUnloadHandler);
}



}


// WEBPACK FOOTER //
// ./src/app/registration/registration-new/registration-new.component.ts